import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as StyledAddressSearchResults from './addressSearchResults.styles';

interface Props {
	data: any;
}

const AddressSearchResults: FC<Props> = ({ data }) => {
	const { t } = useTranslation('generalPostInfo');
	if (!data) return null;
	if (data.length === 0) return <h1>{t('noresult')}</h1>;
	return (
		<StyledAddressSearchResults.Wrapper>
			<table>
				<thead>
					<tr>
						<th>{t('address-search.road')}</th>
						<th>{t('address-search.place')}</th>
					</tr>
				</thead>
				<tbody>
					{data.map(road => {
						road.street1.charAt(0).toUpperCase();
						return (
							<tr key={road.postalCode}>
								<td>{road.street1}</td>
								<td>{`${road.city} ${road.postalCode}`}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</StyledAddressSearchResults.Wrapper>
	);
};

export default AddressSearchResults;
